import { render, staticRenderFns } from "./cuotiFbjlu.vue?vue&type=template&id=228a9e03&scoped=true"
import script from "./cuotiFbjlu.vue?vue&type=script&lang=js"
export * from "./cuotiFbjlu.vue?vue&type=script&lang=js"
import style0 from "./cuotiFbjlu.vue?vue&type=style&index=0&id=228a9e03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228a9e03",
  null
  
)

export default component.exports